/**
 * @typedef {{ label: string, command: string, value: string }} SearchFilterChip
 */

/**
 * Parse a v1-style search string into filter chips and remaining free text.
 * Tokens look like `{label command value}`.
 *
 * @param {string | null | undefined} searchString
 * @returns {{ chips: SearchFilterChip[], freeText: string }}
 */
export function parseSearchString(searchString) {
    if (!searchString) {
        return { chips: [], freeText: "" }
    }

    /** @type {SearchFilterChip[]} */
    const chips = []
    let remainingText = searchString
    const chipRegex = /\{([^}]+)\}/g
    let match

    while ((match = chipRegex.exec(searchString)) !== null) {
        const chipContent = match[1]
        const parts = chipContent.split(" ")
        if (parts.length >= 2) {
            chips.push({
                label: parts[0],
                command: parts[1],
                value: parts.slice(2).join(" "),
            })
        }
        remainingText = remainingText.replace(match[0], "")
    }

    return {
        chips,
        freeText: remainingText.trim(),
    }
}

/**
 * @param {SearchFilterChip[]} chips
 * @param {string} freeText
 * @returns {string}
 */
export function compileSearchString(chips, freeText) {
    const chipString = chips
        .map((chip) => `{${chip.label} ${chip.command} ${chip.value}}`)
        .join("")
    const text = (freeText ?? "").trim()
    return `${chipString}${text}`.trim()
}
